import React from 'react';

import styles from './Button.module.scss';

interface SpaceBetweenButtonWrapperProps {
    leftButtons: JSX.Element[];
    rightButtons: JSX.Element[];
    testId?: string;
    marginTop?: string;
}

export const SpaceBetweenButtonWrapper: React.FC<SpaceBetweenButtonWrapperProps> = ({ leftButtons, rightButtons, testId, marginTop = '0px' }) => (
    <div className={styles.spaceBetweenButtonWrapper} data-testid={`${testId}-button-wrapper`} style={{ marginTop }}>
        <div className={styles.leftButtonWrapper}>
            {leftButtons}
        </div>
        <div className={styles.rightButtonWrapper}>
            {rightButtons}
        </div>
    </div>
);
